const PALETTES = [
  ['bg-blue-50 text-blue-500', 'border-blue-200'],
  ['bg-purple-50 text-purple-700', 'border-purple-200'],
  ['bg-green-50 text-green-700', 'border-green-200'],
  ['bg-amber-50 text-amber-700', 'border-amber-200'],
  ['bg-rose-50 text-rose-700', 'border-rose-200'],
  ['bg-teal-50 text-teal-700', 'border-teal-200'],
];

export const getInitials = (name: string) =>
  name
    .split(' ')
    .map((w) => w[0] ?? '')
    .join('')
    .toUpperCase()
    .slice(0, 2);

interface DillAvatarProps {
  name?: string;
  initials?: string;
  idx?: number;
  size?: number;
}

export const DillAvatar = ({ name, initials, idx = 0, size = 32 }: DillAvatarProps) => {
  const text = initials ?? (name ? getInitials(name) : '');
  const [bg, border] = PALETTES[idx % PALETTES.length];
  return (
    <div
      style={{ width: size, height: size, fontSize: size * 0.35 }}
      className={`rounded-full border flex items-center justify-center font-semibold shrink-0 uppercase ${bg} ${border}`}>
      {text}
    </div>
  );
};
